import {
    AppIntegrationsRepository,
    MeRepository,
    LicensesRepository,
} from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import QRCode from 'qrcodejs2';
import log from 'common/services/logging/loggers';

const _directiveDependencies = [];
const _controllerDependencies = ['$stateParams', '$state', '$window', '$timeout', '$scope', 'Util',
    'DeploymentUrlsRestService'];

class PhoneDeploymentWizardController {

    constructor(
        $stateParams, $state, $window, $timeout,
        $scope, Util, DeploymentUrlsRestService,
    ) {

        this.$scope = $scope;
        this.$state = $state;
        this.$window = $window;
        this.$timeout = $timeout;
        this.Util = Util;
        this.DeploymentUrlsRestService = DeploymentUrlsRestService;
        this.LicensesRepository = LicensesRepository;

        this.user = MeRepository.getMyUser();
        this.isMyEmailConfirmed = this.user.attributes.optin !== 'single';

        this.app = AppIntegrationsRepository.getById(this.$scope.inputData.appId);
        this.$scope.app = this.app;

        this.$scope.deviceOs = window.deviceOs;

        // Remove previous qrcodes
        this.$scope.qrcode = '';

        if (!this.$scope.qrcode) {

            const deploymentPayload = {
                appId: this.$scope.inputData.appId,
                beta: !!this.Util.deepFind(this.license, 'attributes.is_beta_otc'),
                os: this.$scope.inputData.os,
            };

            this.DeploymentUrlsRestService.deploy(deploymentPayload).then((response) => {

                const deployUrl = this.Util.deepFind(response, 'data.data.attributes.download_url');
                log.info(['appId=', this.$scope.inputData.appId, ', DeploymentUrl=', deployUrl || 'undefined'].join(''));
                this.$scope.externalDownloadUrl = deployUrl;

                if (deployUrl) {

                    const qrCodeElemnt = document.getElementById('deploy-mobile-qrcode');

                    // Remove previous qrcodes
                    if (this.$scope.deviceOs === 'windows' || this.$scope.deviceOs === 'mac_os_x') {

                        if (qrCodeElemnt) {

                            qrCodeElemnt.innerHTML = '';

                        }

                        this.$scope.qrcode = new QRCode(qrCodeElemnt, {
                            text: deployUrl,
                            width: 180,
                            height: 180,
                            colorDark: '#000000',
                            colorLight: '#ffffff',
                            correctLevel: QRCode.CorrectLevel.H,
                        });

                    }

                } else {

                    this.$scope.showFallbackQRcode = true;

                }

            }).catch((err) => {

                this.$scope.showFallbackQRcode = true;
                log.error(err);

            });

        }

        this.$scope.inputData = angular.extend(
            this.$scope.inputData,
            { emails: [this.user.attributes.email] },
        );

        if (!this.app) {

            // app not found, close modal
            this.Util.closeModal();

        }

        this.deployChoose = {
            option: 'email',
            isForMe: !!this.user.id,
            waitingResponse: false,
        };

        this.license = this.getLicense();
        this.licenseId = this.Util.deepFind(this.license, 'id') || '';

        // click handler for link to redeploy on current device
        // timeout hack is used to make sure the dom has been loaded
        this.$timeout(() => {

            const deployViaDownloadElement = angular.element(document.querySelector('#deployActionDownload a'));
            deployViaDownloadElement.on('click', () => this.deployViaAppStore());

        }, 0);

        // check if we should display the auto install UI
        this.autoInstall = this.$scope.inputData.autoInstall;

        // if we can automatically install the product initiate deploy sequence
        if (this.autoInstall) {

            this.deployViaAppStore();

        }

        // if we get back to the deployment wizard a second time
        // when we deploy on another device, we disable auto install
        this.$scope.inputData = angular.extend(this.$scope.inputData, {
            autoInstall: false,
        });

    }

    getPageName() {

        let pageName = '';

        if (this.$state.current.name.indexOf('.home') > -1) {

            pageName = 'Homepage';

        } else if (this.$state.current.name.indexOf('.devices') > -1) {

            pageName = 'Devices';

        } else if (this.$state.current.name.indexOf('.products') > -1) {

            pageName = 'Products';

        } else if (this.$state.current.name.indexOf('.subscriptions') > -1) {

            pageName = 'Subscriptions';

        }

        return pageName;

    }

    getLicense() {

        let licenseData;
        const licenseResourceId = this.$state.params.resourceId;

        // try to get license from license id or activation code from URL resourceId param
        licenseData = this.LicensesRepository.getLicenseBy(licenseResourceId) ||
                      this.LicensesRepository.getLicenseById(licenseResourceId);

        // try to get license from LicenseRepository based of app id (case for bundle)
        if (!licenseData) {

            licenseData = this.LicensesRepository.getLicenseByAppId(this.$scope.inputData.appId);

        }

        // license not found, try to find license based on component
        if (typeof licenseData === 'undefined') {

            const allLicenses = this.LicensesRepository.getAll();

            /**
             * Search each appid of each license in appIntegrationRepository
             */
            allLicenses.forEach((license) => {

                // bundle id of each license
                const licenseBundleId = license.relationships.app.data.id;

                // get app integration for the bundle id of license
                const appIntegration = AppIntegrationsRepository.getById(licenseBundleId);

                // stop at first find
                if (!licenseData && this.Util.deepFind(appIntegration, 'relationships.apps')) {

                    // search component to be deployed (from URL) in components of the bundle
                    appIntegration.relationships.apps.data.find((app) => {

                        // component found === license found
                        if (app.id === this.$scope.inputData.appId) {

                            licenseData = license;
                            return true;

                        }

                        return false;

                    });

                }

            });

        }

        return licenseData;

    }

    qrSelected() {

        const deploymentPayload = {
            appId: this.$scope.inputData.appId,
            beta: !!this.Util.deepFind(this.license, 'attributes.is_beta_otc'),
            os: this.$scope.inputData.os,
        };

        // Generate the qrcode only once
        if (!this.$scope.qrcode) {

            this.DeploymentUrlsRestService.deploy(deploymentPayload).then((response) => {

                const deployUrl = this.Util.deepFind(response, 'data.data.attributes.download_url');
                log.info(['appId=', this.$scope.inputData.appId, ', DeploymentUrl=', deployUrl || 'undefined'].join(''));
                if (deployUrl) {

                    const qrCodeElemnt = document.getElementById('deploy-mobile-qrcode');

                    // Remove previous qrcodes
                    if (qrCodeElemnt) {

                        qrCodeElemnt.innerHTML = '';

                    }

                    this.$scope.qrcode = new QRCode(qrCodeElemnt, {
                        text: deployUrl,
                        width: 180,
                        height: 180,
                        colorDark: '#000000',
                        colorLight: '#ffffff',
                        correctLevel: QRCode.CorrectLevel.H,
                    });

                } else {

                    this.$scope.showFallbackQRcode = true;

                }

            }).catch((err) => {

                this.$scope.showFallbackQRcode = true;
                log.error(err);

            });

        }

        this.deployChoose.option = 'qr';
        Mixpanel.send(
            'ConnectWeb Deployment QR Scan Tab Open',
            {
                Product: this.Util.deepFind(this.app, 'attributes.resource.oeName'),
                'Product OS': this.$scope.inputData.os,
                'New User': !this.deployChoose.isForMe,
                'Product ID': this.app.id,
            },
        );

    }

    deployViaEmail() {

        Mixpanel.send(
            'ConnectWeb Deployment Email Click',
            {
                Product: this.Util.deepFind(this.app, 'attributes.resource.oeName'),
                'Product OS': this.$scope.inputData.os,
                'New User': !this.deployChoose.isForMe,
                'Product ID': this.app.id,
                'Device Os': window.deviceOs,
                Page: this.getPageName(),
            },
        );

        this.deployChoose.waitingResponse = true;

        const deploymentPayload = {
            appId: this.$scope.inputData.appId,
            license_type: (this.licenseId !== '') ? 'paid' : 'free',
            download_source: (this.licenseId !== '') ? 'wdp' : 'wdf',
            licenseId: this.licenseId,
            beta: !!this.Util.deepFind(this.license, 'attributes.is_beta_otc'),
            os: this.$scope.inputData.os,
            meta: {
                send_email: true,
                email: this.user.attributes.email,
            },
        };

        this.DeploymentUrlsRestService.deploy(deploymentPayload).then(() => {

            // success handler

            this.deployChoose.waitingResponse = false;
            this.$scope.inputData = { emails: [this.user.attributes.email] };
            this.$scope.showSuccessScreen()('email', 'phone', {});

        }, () => {

            // error handler

            Alert.error({
                message: 'cw.modal.server-error.desc',
                icon: {
                    cssClasses: 'icon-phone',
                },
            });
            this.Util.closeModal();

        });

    }

    deployViaSMS() {

        const isValidPhoneNumber =
            this.Util.isValidPhoneNumber(
                this.Util.deepFind(this.$scope.selectedDevice, 'phoneNumber'),
                this.Util.deepFind(this.$scope.selectedDevice, 'country.code'),
            );
        if (!isValidPhoneNumber) {

            Alert.error({
                message: 'cw.notification.svc.instance.error.phone_invalid',
                icon: {
                    cssClasses: 'icon-phone',
                },
            });
            return;

        }

        this.deployChoose.waitingResponse = true;
        Mixpanel.send(
            'ConnectWeb Deployment SMS Click',
            {
                Product: this.Util.deepFind(this.app, 'attributes.resource.oeName'),
                'Product OS': this.$scope.inputData.os,
                'Product ID': this.app.id,
            },
        );
        const countryCode = this.Util.deepFind(this.$scope.selectedDevice, 'country.dialCode') || '';

        if (this.$scope.selectedDevice.phoneNumber.indexOf(countryCode) === 0) {

            this.phoneNumber = this.$scope.selectedDevice.phoneNumber.replace(countryCode, '');

        } else {

            this.phoneNumber = this.$scope.selectedDevice.phoneNumber;

        }

        const deploymentPayload = {
            appId: this.$scope.inputData.appId,
            license_type: (this.licenseId !== '') ? 'paid' : 'free',
            download_source: (this.licenseId !== '') ? 'wdp' : 'wdf',
            licenseId: this.licenseId,
            os: this.$scope.inputData.os,
            beta: !!this.Util.deepFind(this.license, 'attributes.is_beta_otc'),
            meta: {
                send_sms: true,
                phone_number: countryCode + this.phoneNumber,
            },
        };

        this.DeploymentUrlsRestService.deploy(deploymentPayload).then(() => {

            // success handler
            this.$scope.inputData = {
                phoneNumber: this.phoneNumber,
                dialCode: countryCode,
                appId: this.app.id,
                appName: this.Util.deepFind(this.app, 'attributes.resource.oeName'),
                os: this.$scope.inputData.os,
            };
            this.$scope.dynamicDirectiveTag = '<phone-sms-deployment-success />';

        }, (error) => {

            const errorCode =
                (error.data.errors && error.data.errors[0]) ? error.data.errors[0].code : false;

            switch (errorCode) {

            case '1208': // maximum number of SMS exceeded

                Alert.error({
                    message: 'cw.device.resend.sms_error',
                    icon: {
                        cssClasses: 'icon-phone',
                    },
                });

                break;

            default:

                Alert.error({
                    message: 'cw.modal.server-error.desc',
                    icon: {
                        cssClasses: 'icon-phone',
                    },
                });

            }

            this.Util.closeModal();

        });

    }

    deployViaAppStore() {

        Mixpanel.send(
            'ConnectWeb Deployment Download Click',
            {
                Product: this.Util.deepFind(this.app, 'attributes.resource.oeName'),
                'Product OS': this.$scope.inputData.os,
                'Product ID': this.$scope.inputData.appId,
            },
        );

        this.deployChoose.waitingResponse = true;

        const deploymentPayload = {
            appId: this.$scope.inputData.appId,
            license_type: (this.licenseId !== '') ? 'paid' : 'free',
            download_source: (this.licenseId !== '') ? 'wdp' : 'wdf',
            license_number: this.licenseId,
            os: this.$scope.inputData.os,
        };

        this.DeploymentUrlsRestService.deploy(deploymentPayload)
            .then((response) => {

            // success handler


                this.deployChoose.waitingResponse = false;
                let downloadUrl = this.Util.deepFind(response, 'data.data.attributes.download_url');
                log.info(['appId=', this.$scope.inputData.appId, ', DeploymentUrl=', downloadUrl || 'undefined'].join(''));
                if (downloadUrl) {

                    downloadUrl = `${downloadUrl}${this.Util.getNextDelimiter(downloadUrl)}utm_source=cw`;
                    this.$window.location.href = downloadUrl;

                } else {

                    Alert.error({
                        message: 'cw.modal.server-error.desc',
                        icon: {
                            cssClasses: 'icon-pc',
                        },
                    });
                    this.Util.closeModal();

                }

            }, () => {

            // error handler

                Alert.error({
                    message: 'cw.modal.server-error.desc',
                    icon: {
                        cssClasses: 'icon-pc',
                    },
                });
                this.Util.closeModal();

            });

    }

    deployOnAnotherDevice() {

        let stateName = this.$state.current.name;

        if (stateName.indexOf('.deploy') === -1) {

            stateName += '.deploy';

        }

        let stateParams = angular.extend({ ltb: 'deploy' }, this.$stateParams);

        // if we're on the subscriptions page we always install on a new device
        // to simplify the flow
        if (stateName.indexOf('subscriptions') !== -1 ||
            stateName.indexOf('home') !== -1) {

            stateParams = angular.extend(stateParams, { deviceId: 'new', appId: this.$scope.inputData.appId });

        }

        let page = 'None';

        if (stateName.indexOf('.products') !== -1) {

            page = 'Products';

        } else if (stateName.indexOf('.subscriptions') !== -1) {

            page = 'Subscriptions';

        } else if (stateName.indexOf('.home') !== -1) {

            page = 'Homepage';

        }

        Mixpanel.send(
            'ConnectWeb Install Click',
            {
                Product: this.Util.deepFind(this.app, 'attributes.resource.oeName'),
                'Product ID': this.app.id,
                Page: page,
                Label: 'Other Device',
            },
        );

        this.$scope.changeWizard()(stateName, stateParams, {
            reload: false,
        });

    }

    deployViaAppStoreMixpanel() {

        Mixpanel.send(
            'ConnectWeb Deployment AppStore Click',
            {
                'Product OS': this.$scope.inputData.os,
            },
        );

    }

}


class PhoneDeploymentWizardDirective {

    constructor() {

        this.template = require('./phone-deployment-wizard.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push((
            $stateParams, $state, $window, $timeout, $scope, Util,
            DeploymentUrlsRestService,
        ) =>
            new PhoneDeploymentWizardController(
                $stateParams, $state, $window, $timeout, $scope, Util,
                DeploymentUrlsRestService,
            ));

        this.controller = _controllerDependencies;
        this.controllerAs = 'phoneDeploymentWizardCtrl';

    }

}

_directiveDependencies.push(() =>
    new PhoneDeploymentWizardDirective());

angular.module('directives')
    .directive('phoneDeploymentWizard', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/deployment/phone-deployment-wizard/phone-deployment-wizard.js